<ng-container *ngIf="!showSSOButton">
  <form
    [formGroup]="form"
    (ngSubmit)="submitForm(form)"
    class="margin-bottom-24"
  >
    <mat-form-field class="u-marginBottom-8 mat-form-field-width-100">
      <mat-label i18n="@@signupView.firstNameLabel">First Name</mat-label>
      <input
        matInput
        autocomplete="off"
        formControlName="first_name"
        required
      />
    </mat-form-field>
    <mat-form-field class="u-marginBottom-8 mat-form-field-width-100">
      <mat-label i18n="@@signupView.lastNameLabel">Last Name</mat-label>
      <input matInput autocomplete="off" formControlName="last_name" required />
    </mat-form-field>
    <mat-form-field class="u-marginBottom-8 mat-form-field-width-100">
      <mat-label i18n="@@global.email">Email</mat-label>
      <input
        matInput
        type="email"
        autocomplete="off"
        formControlName="email"
        required
      />
    </mat-form-field>
    <mat-error *ngIf="!!form.getError('server')" class="u-marginBottom-16">
      <span i18n="@@signupView.serverError"
        >{ form.getError('server'), select, other
        {{{ form.getError('server') }}} }</span
      >
    </mat-error>
    <div class="u-marginBottom-16">
      <mat-checkbox
        class="mat-checkbox--longText u-display-block"
        [formControl]="agreementFormControl"
        disableRipple="true"
      >
        <p
          i18n="@@signupView.termsAndConditionsPrompt"
          class="text-caption color-grey-300"
        >
          By signing up, you are agreeing to our
          <a
            href="https://www.tenthousandcoffees.com/terms-conditions"
            class="color-blue"
            >Terms of Service</a
          >,
          <span *ngIf="!tenant.legal?.link">and </span>
          <a
            href="https://www.tenthousandcoffees.com/privacy-policy"
            class="color-blue"
            >Privacy Policy</a
          >
          <ng-container *ngIf="!tenant?.legal?.link">.</ng-container>
          <ng-container *ngIf="tenant?.legal?.link">
            and {{ tenant?.friendly_name | textToPossessive }}
            <a
              [href]="tenant?.legal?.link"
              target="_blank"
              class="color-blue"
              >{{ tenant.legal?.title }}</a
            >.
          </ng-container>
        </p>
      </mat-checkbox>
    </div>
    <div fxLayout="row" fxLayoutAlign="start center">
      <button
        mat-raised-button
        type="submit"
        color="primary"
        [disabled]="!form.valid || isLoading || !agreementFormControl.value"
      >
        <span i18n="@@signupView.joinCta">Join</span>
        <i
          *ngIf="isLoading"
          nz-icon
          nzType="sync"
          nzTheme="outline"
          nzSpin
          class="u-marginLeft-8"
        ></i>
      </button>
    </div>
    <p
      *ngIf="tenant?.integrations?.workos?.sso_signup_enabled"
      i18n="@@signupView.joinWithSSOPrompt"
      class="color-grey-300 u-paddingTop-16"
    >
      Or,
      <button
        class="c-button color-blue"
        (click)="showSSOButton = true"
        type="button"
      >
        use your team's Single sign-on authentication</button
      >.
    </p>
  </form>
</ng-container>
<ng-container *ngIf="showSSOButton">
  <app-sso-signin
    [ssoErrorMessage]="ssoErrorMessage"
    [ssoErrorStatus]="ssoErrorStatus"
    [showPrivacyDisclaimer]="true"
    [ssoSignInParams]="ssoSignInParams"
    [tenant]="tenant"
    class="u-display-block"
  ></app-sso-signin>
  <p
    *ngIf="tenant.email_login_enabled"
    i18n="@@signupView.joinWithEmailPrompt"
    class="color-grey-300 u-paddingTop-16"
  >
    Or,
    <button
      class="c-button color-blue"
      (click)="showSSOButton = false"
      type="button"
    >
      use a magic link via your email address</button
    >.
  </p>
</ng-container>
